var bordercolor = getComputedStyle(document.body).getPropertyValue('--bordercolor');
var bodycolor = getComputedStyle(document.body).getPropertyValue('--bodycolor');
var primarycolor = getComputedStyle(document.body).getPropertyValue('--vs-primary');
export default [
    {
        todayorders:
        {
            options: {
                chart: {
                    sparkline: {
                        enabled: true,
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: "#000",
                        opacity: 0.7,
                    },
                },

                stroke: {
                    curve: "smooth",
                    width: 2,
                },
                markers: {
                    size: 0,
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0,
                    },
                },
                colors: ["#1e3d73"],
                tooltip: {
                    x: {
                        show: false,
                    }
                },
                responsive: [
                    {
                        breakpoint: 1351,
                        options: {
                            chart: {
                                height: 95,
                            },
                            grid: {
                                padding: {
                                    top: 35,
                                    bottom: 0,
                                    left: 0,
                                },
                            },
                        },
                    },
                    {
                        breakpoint: 1200,
                        options: {
                            chart: {
                                height: 80,
                            },
                            grid: {
                                padding: {
                                    top: 35,
                                    bottom: 0,
                                    left: 40,
                                },
                            },
                        },
                    },
                    {
                        breakpoint: 576,
                        options: {
                            chart: {
                                height: 95,
                            },
                            grid: {
                                padding: {
                                    top: 45,
                                    bottom: 0,
                                    left: 0,
                                },
                            },
                        },
                    },
                ],
            },
            series: [
                {
                    data: [41, 9, 36, 12, 44, 25, 59, 41, 66, 25],
                },
            ],
        },
        todayvisitors:
        {
            options:
            {

                chart: {
                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#28a745',
                        opacity: 0.7,
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                colors: ['#28a745'],
                tooltip: {
                    x: {
                        show: false
                    }
                },
                responsive: [{
                    breakpoint: 1351,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        chart: {
                            height: 80,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 40
                            }
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 45,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                }

                ]

            }
            ,
            series: [{
                data: [41, 9, 36, 12, 44, 25, 59, 41, 66, 25]
            }]
        },
        todaysale:
        {
            options:
            {

                chart: {
                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#17a2b8',
                        opacity: 0.7,
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                colors: ['#17a2b8'],
                tooltip: {
                    x: {
                        show: false
                    }
                },
                responsive: [{
                    breakpoint: 1351,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        chart: {
                            height: 80,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 40
                            }
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 45,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                }

                ]
            },
            series: [{
                data: [7, 9, 36, 12, 44, 25, 59, 41, 12, 25]
            }]
        },
        totalprofit:
        {
            options:
            {
                chart: {

                    sparkline: {
                        enabled: true
                    },
                    dropShadow: {
                        enabled: true,
                        top: 1,
                        left: 1,
                        blur: 2,
                        color: '#ffc107',
                        opacity: 0.7,
                    }
                },
                stroke: {
                    curve: 'smooth',
                    width: 2,
                },
                markers: {
                    size: 0
                },
                grid: {
                    padding: {
                        top: 0,
                        bottom: 0,
                        left: 0
                    }
                },
                colors: ['#ffc107'],
                tooltip: {
                    x: {
                        show: false
                    }
                },
                responsive: [{
                    breakpoint: 1351,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                },
                {
                    breakpoint: 1200,
                    options: {
                        chart: {
                            height: 80,
                        },
                        grid: {
                            padding: {
                                top: 35,
                                bottom: 0,
                                left: 40
                            }
                        },
                    },
                },
                {
                    breakpoint: 576,
                    options: {
                        chart: {
                            height: 95,
                        },
                        grid: {
                            padding: {
                                top: 45,
                                bottom: 0,
                                left: 0
                            }
                        },
                    },
                }

                ]
            },
            series: [{
                data: [21, 9, 36, 12, 44, 25, 59, 41, 66, 25]
            }]
        },
        mainbarchart:
        {
            series: [{
                name: 'Orders',
                type: 'area',
                data: [23, 11, 22, 27, 13, 22, 37, 21, 44, 22, 30]
            }, {
                name: 'Sale',
                type: 'area',
                data: [30, 25, 36, 30, 45, 35, 64, 52, 59, 36, 39]
            }],
            options: {
               
                chart: {
                    height: 462,
                    type: 'area',
                    stacked: false,
                },
                responsive: [
                    {
                        breakpoint: 767,
                        options: {
                            chart: {
                                height: 262
                            }
                        }
                    }
                ],
                stroke: {
                    width: [1, 1, 1],
                    curve: 'smooth'
                },
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                colors: ['#1e3d73', '#17a2b8'],
              
                fill: {
                    opacity: [0.85, 0.25, 1],
                    gradient: {
                        inverseColors: false,
                        shade: 'light',
                        type: "vertical",
                        opacityFrom: 0.85,
                        opacityTo: 0.55,
                        stops: [0, 100, 100, 100]
                    }
                },
                labels: ['01/01/2003', '02/01/2003', '03/01/2003', '04/01/2003', '05/01/2003', '06/01/2003', '07/01/2003', '08/01/2003', '09/01/2003', '10/01/2003', '11/01/2003'],
                markers: {
                    size: 0
                },
                xaxis: {
                    type: 'datetime'
                },
                yaxis: {
                    min: 0
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function (y) {
                            if (typeof y !== "undefined") {
                                return  y.toFixed(0) + " views";
                            }
                            return y;
                        }
                    }
                },
                legend: {
                    labels: {
                        useSeriesColors: true
                    }
                }
            }
        },
        countrydata:
        {
            options:
            {

                grid: {
                    yaxis: {
                        lines: {
                            show: false,
                        },
                    },
                },

                plotOptions: {
                    bar: {
                        horizontal: true,
                        columnWidth: "10",
                    },
                },
                dataLabels: {
                    enabled: false,
                },
                colors: ["#1e3d73"],
                series: [
                    {
                        data: [400, 430, 448, 470, 540, 580],
                    },
                ],
                xaxis: {
                    categories: [
                        "South Korea",
                        "Canada",
                        "United Kingdom",
                        "Netherlands",
                        "Italy",
                        "France",
                    ],
                }
            },
            series: [
                {
                    data: [400, 430, 448, 470, 540, 580],
                },
            ]
        },
        cityreport:
        {
            options:
            {
                chart: {
                    stacked: true,
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: true
                    }
                },
                plotOptions: {
                    bar: {
                        horizontal: false,
                    },
                },
                grid: {
                    show: false,
                    padding: {
                        left: -20,
                        bottom: -15
                    }
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    lines: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                yaxis: {
                    labels: {
                        show: false
                    },
                    lines: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },
                    axisTicks: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
                fill: {
                    opacity: 1
                },
                bar: {
                    columnWidth: 10
                },
                dataLabels: {
                    enabled: false
                },
                colors: ["#1e3d73", '#ffc107'],
            },
            series: [{
                name: 'PRODUCT A',
                data: [13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27,13, 23, 20, 8, 13, 27, 13, 23, 20, 8, 13, 27]
            }, {
                name: 'PRODUCT B',
                data: [44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43,44, 55, 41, 67, 22, 43, 44, 55, 41, 67, 22, 43]
            }],
        },
        donut:
        {
            series: [3, 28, 67],
            options: {                
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: true,
                    position: 'bottom',
                },
                colors: ["#1e3d73", '#17a2b8', '#ffc107'],
                responsive: [{
                    breakpoint: 480,
                    options: {
                        chart: {
                            width: 200
                        },
                        legend: {
                            position: 'bottom'
                        }
                    }
                }]
            },
        }
    }
]
